/* globals App */

import axios from 'axios';

export class Addresses {
  constructor() {
    document.body.addEventListener('modals-ready', (e) => {
      this.modal = App.modals.getModal('edit-address-modal');
    });
    let form = document.querySelector('form#addressForm');
    this.states = window.states;
    this.countriesWithTaxId = window.countriesWithTaxId;
    document.addEventListener('DOMContentLoaded', () => {
      if (form) {
        this.initAddressForm(form);
      }
    });
    console.log('Addresses initialised');
  }

  initAddressLinks(container) {
    let links = container.querySelectorAll('.js-edit-address');
    if (!links.length) {
      return;
    }
    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        let id = link.dataset.id ? link.dataset.id : '';
        let primaryBilling = link.dataset.primaryBilling ? link.dataset.primaryBilling : '';
        let url = '/?action=site/addresses/form&validate=1&id=' + id + '&primaryBilling=' + primaryBilling;
        this.modal.settings.ajaxUrl = url;
        this.modal.contentLoaded = false;
        this.modal.settings.onAjaxLoaded = () => {
          let form = this.modal.content.querySelector('form');
          this.initAddressForm(form);
          let options = JSON.parse(form.dataset.options);
          options.onSuccess = (response) => {
            const event = new CustomEvent('addressSaved', { detail: response.model });
            document.body.dispatchEvent(event);
            this.modal.close();
          };
          App.forms.create(form, options);
        };
        this.modal.open();
      });
    });
  }

  initAddressForm(form) {
    let countrySelect = form.querySelector('[name=countryCode]');
    let businessName = form.querySelector('[name=organization]');
    let taxIdLabel = form.querySelector('[name=organizationTaxId]').previousElementSibling;
    const requireTaxId = () => {
      if ((countrySelect.value && this.countriesWithTaxId.includes(countrySelect.value)) || businessName.value.length > 0) {
        taxIdLabel.classList.add('is-required');
      } else {
        taxIdLabel.classList.remove('is-required');
      }
    };
    requireTaxId();
    businessName.addEventListener('keyup', requireTaxId);
    this.switchFields(form);
    if (countrySelect) {
      this.changePhoneCode(form);
      countrySelect.addEventListener('change', () => {
        this.switchFields(form);
        requireTaxId();
        this.changePhoneCode(form);
      });
    }
    let phoneField = form.querySelector('.js-phone-number');
    let phoneCode = form.querySelector('.js-phone-code');
    phoneCode.addEventListener('change', () => {
      this.validatePhone(form);
    });
    phoneField.addEventListener('blur', () => {
      this.validatePhone(form);
    });
  }

  changePhoneCode(form) {
    let countrySelect = form.querySelector('[name=countryCode]');
    let phoneCode = form.querySelector('.js-phone-code');
    if (countrySelect.value) {
      phoneCode.value = countrySelect.value;
      this.validatePhone(form);
    }
  }

  validatePhone(form) {
    let phoneField = form.querySelector('.js-phone-number');
    let phoneCode = form.querySelector('.js-phone-code');
    if (!phoneField.value) {
      return;
    }
    const formInstance = App.forms.getForm(form);
    formInstance.disableSubmit();
    axios
      .get('/?action=site/addresses/validate-phone&code=' + phoneCode.value + '&phone=' + phoneField.value, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        this.removePhoneErrors(form);
        if (response.data.valid) {
          form.querySelector('.js-phone-number').value = response.data.localPhone;
        } else {
          let error = document.createElement('p');
          error.classList.add('field-error');
          error.setAttribute('data-form-field-error', '');
          error.innerHTML = 'This phone number is invalid';
          let container = phoneField.closest('.form-field');
          container.append(error);
          container.classList.add('has-error');
        }
      })
      .finally(() => {
        formInstance.enableSubmit();
      });
  }

  removePhoneErrors(form) {
    let phoneField = form.querySelector('.js-phone-number');
    let container = phoneField.closest('.form-field');
    container.classList.remove('has-error');
    container.querySelectorAll('.field-error').forEach((error) => {
      error.remove();
    });
  }

  switchFields(form) {
    if (!this.states) {
      throw new Error('Address states are missing on the window');
    }
    let countrySelect = form.querySelector('[name=countryCode]');
    if (!countrySelect.value) {
      return;
    }
    let stateCustom = form.querySelector('.stateCustom');
    let stateSelect = form.querySelector('.stateSelect');
    let postcodeField = form.querySelector('[name=postalCode]');
    let cityField = form.querySelector('[name=locality]');
    let stateWrapper = form.querySelector('.state-wrapper');
    let cityWrapper = form.querySelector('.city-wrapper');
    let postcodeWrapper = form.querySelector('.postcode-wrapper');
    axios
      .get('/?action=site/addresses/fields&country=' + countrySelect.value, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        let data = response.data;
        let requiresState = false;
        let country = countrySelect.value;
        if (data.includes('administrativeArea')) {
          requiresState = true;
          stateWrapper.classList.remove('hidden');
        } else {
          stateSelect.disabled = true;
          stateCustom.disabled = true;
          stateWrapper.classList.add('hidden');
        }
        if (data.includes('locality')) {
          cityField.disabled = false;
          cityWrapper.classList.remove('hidden');
        } else {
          cityField.disabled = true;
          cityWrapper.classList.add('hidden');
        }
        if (data.includes('postalCode')) {
          postcodeField.disabled = false;
          postcodeWrapper.classList.remove('hidden');
        } else {
          postcodeField.disabled = true;
          postcodeWrapper.classList.add('hidden');
        }
        if (requiresState) {
          if (country && this.states[country]) {
            stateSelect.innerHTML = '';
            let state = document.createElement('option');
            state.value = '';
            state.innerHTML = 'Select state';
            stateSelect.appendChild(state);
            Object.keys(this.states[country]).forEach((index) => {
              let state = document.createElement('option');
              state.value = index;
              state.innerHTML = this.states[country][index];
              stateSelect.appendChild(state);
            });
            stateSelect.closest('.wrapper').classList.remove('hidden');
            stateCustom.closest('.wrapper').classList.add('hidden');
            stateSelect.disabled = false;
            stateCustom.disabled = true;
            stateSelect.name = 'administrativeArea';
            stateCustom.name = '';
            if (stateSelect.closest('.wrapper').dataset.value) {
              stateSelect.value = stateSelect.closest('.wrapper').dataset.value;
            } else {
              stateSelect.value = '';
            }
          } else {
            stateSelect.closest('.wrapper').classList.add('hidden');
            stateCustom.closest('.wrapper').classList.remove('hidden');
            stateSelect.disabled = true;
            stateCustom.disabled = false;
            stateCustom.name = 'administrativeArea';
            stateSelect.name = '';
          }
        }
      });
  }
}
